import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { BannerViewType, PcodeRenderData } from '../../typings/pcode';
import { CanvasCreativePreviewIFrame } from '../CanvasCreativePreviewIFrame/CanvasCreativePreviewIFrame';
import { ModalDecorator } from '../ModalDecorator/ModalDecorator';

import './CreativePreviewIFrame.css';

export interface CreativeCanvasIFrameProps {
    previewData: PcodeRenderData;
    previewUrl?: string;
    onOutsideClick: () => void;
    isVisible: boolean;
}

export class CreativePreviewIFrame extends React.PureComponent<
    CreativeCanvasIFrameProps
> {
    render() {
        const {
            previewData,
            previewUrl,
            onOutsideClick,
            isVisible
        } = this.props;
        const { type, size, isSquareFormat } = previewData;
        let width;
        let height;

        switch (type) {
            case BannerViewType.videoAdditionPreview:
                width = isSquareFormat ? 480 : 800;
                height = 480;
                break;
            case BannerViewType.adaptive0418:
            default:
                width = (size && size.width) || undefined;
                height = (size && size.height) || undefined;
                break;
        }

        return (
            <ModalDecorator
                visible={Boolean(isVisible)}
                cls={Bem.cls('creative-preview-iframe')}
                theme="clear"
                onOutsideClick={onOutsideClick}
            >
                {isVisible && (
                    <div style={{ width, height }}>
                        {type === BannerViewType.plainImagePreview ? (
                            <img
                                src={previewUrl}
                                height={height}
                                width={width}
                            />
                        ) : (
                            <CanvasCreativePreviewIFrame
                                previewData={previewData}
                                videoUrl={previewUrl}
                                width={width}
                                height={height}
                                type={type}
                            />
                        )}
                    </div>
                )}
            </ModalDecorator>
        );
    }
}
